import React from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Button,
  IconButton,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "./filterNewForDBSearch.scss";
import CloseIcon from "@mui/icons-material/Close";

const FilterNewForDBSearch = (props) => {
  const {
    index,
    filtersData,
    parameters,
    handleChangeFilter,
    clearFirstFilter,
    handleRemoveFilter,
  } = props;

  const range = ["Exact", "Range"];

  return (
    <Grid container className="filter-inputs" spacing={1} alignItems="center">
      <Grid className="action-select-wrap" item md={4}>
        <Autocomplete
          id="combo-box-demo"
          size="small"
          className="input-drop-select"
          options={Array.isArray(parameters) ? parameters : []}
          value={filtersData?.parameterName || null}
          renderInput={(params) => (
            <TextField {...params} label="Parameter Name" />
          )}
          onChange={(e, value) =>
            handleChangeFilter(index, {
              parameterName: value,
              rangeType: "Exact",
              minValue: "",
              maxValue: "",
            })
          }
        />
      </Grid>

      <Grid item md={2}>
        <Autocomplete
          disableClearable
          disabled={filtersData?.parameterName ? false : true}
          id="combo-box-demo"
          size="small"
          className="input-drop-select"
          options={range || []}
          value={filtersData?.rangeType || "Exact"}
          onChange={(e, value) =>
            handleChangeFilter(index, {
              ...filtersData,
              rangeType: value,
            })
          }
          renderInput={(params) => <TextField {...params} label="Range" />}
        />
      </Grid>
      <Grid item md={5} className="date_picker">
        {filtersData?.rangeType === "Exact" ? (
          <TextField
            type="text"
            size="small"
            label="Value"
            value={filtersData?.minValue}
            onChange={(event) =>
              handleChangeFilter(index, {
                ...filtersData,
                minValue: event?.target?.value,
              })
            }
            disabled={filtersData?.parameterName ? false : true}
          />
        ) : (
          <>
            <TextField
              type="number"
              size="small"
              label="Value"
              value={filtersData?.minValue}
              onChange={(event) =>
                handleChangeFilter(index, {
                  ...filtersData,
                  minValue: event?.target?.value,
                })
              }
              disabled={filtersData?.parameterName ? false : true}
            />

            <TextField
              style={{ paddingLeft: "8px" }}
              type="number"
              size="small"
              label="Value"
              value={filtersData?.maxValue}
              onChange={(event) =>
                handleChangeFilter(index, {
                  ...filtersData,
                  maxValue: event?.target?.value,
                })
              }
              disabled={filtersData?.parameterName ? false : true}
            />
          </>
        )}
      </Grid>
      <Grid item md={1} container alignItems="center" justifyContent="center">
        {index === 0 ? (
          <Button
            className="btn-search"
            onClick={() => clearFirstFilter()}
            disabled={filtersData?.parameterName ? false : true}
          >
            Clear
          </Button>
        ) : (
          <IconButton onClick={() => handleRemoveFilter(index)}>
            <CloseIcon />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

export default FilterNewForDBSearch;
